import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

/**
 * Per-page header (redesign-admin.md §0 D2): H1 on the §9 scale + optional
 * subline, with a right-aligned action slot. The action slot should hold at
 * most one filled button (docs/15 §8 — one primary action per view).
 */
export function PageHeader({
  title,
  subline,
  children,
  className,
}: {
  title: ReactNode;
  subline?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-3', className)}>
      <div>
        <h1 className="font-head text-h1 font-semibold">{title}</h1>
        {subline && <div className="mt-0.5 text-sm text-muted-foreground">{subline}</div>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
